module.exports = __webpack_public_path__ + "static/img/drive-icon-and-name.be5020d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/drive-icon-and-name.png
// module id = Bts5
// module chunks = 0